import { render } from "./SenderCreate.vue?vue&type=template&id=038876a4"
import script from "./SenderCreate.vue?vue&type=script&lang=js"
export * from "./SenderCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__